module.exports = __webpack_public_path__ + "static/media/UserDiscount2.6d1f878e.svg";